<div [hidden]="!isLoading">
  <spinner></spinner>
</div>
